import { render, staticRenderFns } from "./Divisions.vue?vue&type=template&id=827c925a&scoped=true&"
import script from "./Divisions.vue?vue&type=script&lang=js&"
export * from "./Divisions.vue?vue&type=script&lang=js&"
import style0 from "./Divisions.vue?vue&type=style&index=0&id=827c925a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827c925a",
  null
  
)

export default component.exports